import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import emailjs from '@emailjs/browser';
import ContactShell from '../components/ContactShell';
import { FormContext } from '../context/FormContext';

function ContactStep1() {
  const navigate = useNavigate();
  const { formData, setFormData, resetForm } = useContext(FormContext);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs.sendForm(
      process.env.REACT_APP_EMAILJS_SERVICE_ID,
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
      e.target,
      process.env.REACT_APP_EMAILJS_PUBLIC_KEY
    ).then(
      () => {
        alert('Form submitted, thank you.');
        resetForm();
        navigate('/');
      },
      (error) => {
        console.error('Form submission failed:', error?.status, error?.text || error);
        alert('Something went wrong. Please try again.');
      }
    );
  };

  return (
    <ContactShell>
      <form className="contact-form" onSubmit={handleSubmit}>
        <h3>Investor Information</h3>
        <div className="card-divider"></div>

        <label className="field">
          <span>Legal Entity Name</span>
          <input
            name="entity_name"
            required
            value={formData.entity_name || ''}
            onChange={handleChange}
          />
        </label>
        <label className="field">
          <span>Primary Contact Name</span>
          <input
            name="contact_name"
            required
            value={formData.contact_name || ''}
            onChange={handleChange}
          />
        </label>
        <label className="field">
          <span>Email Address</span>
          <input
            name="email"
            type="email"
            required
            value={formData.email || ''}
            onChange={handleChange}
          />
        </label>
        <label className="field">
          <span>Country of Registration</span>
          <input
            name="country"
            value={formData.country || ''}
            onChange={handleChange}
          />
        </label>
        <label className="field">
          <span>Investor Type</span>
          <select
            name="investor_type"
            required
            value={formData.investor_type || ''}
            onChange={handleChange}
          >
            <option value="" disabled>Select an option</option>
            <option value="UK High Net Worth Individual">UK High Net Worth Individual</option>
            <option value="UK Sophisticated Individual">UK Sophisticated Individual</option>
            <option value="UK/EU Elective Professional">UK/EU Elective Professional</option>
            <option value="UK/EU Per Se Professional">UK/EU Per Se Professional</option>
            <option value="US Accredited Investor">US Accredited Investor</option>
            <option value="US Qualified Eligible Investor">US Qualified Eligible Investor</option>
          </select>
        </label>

        <div className="contact-actions">
          <button type="submit" className="pill-btn">Submit</button>
        </div>
      </form>
    </ContactShell>
  );
}

export default ContactStep1;
